import { render, staticRenderFns } from "./BlogPostCardFilters2.vue?vue&type=template&id=5e207b0e&"
import script from "./BlogPostCardFilters2.vue?vue&type=script&lang=js&"
export * from "./BlogPostCardFilters2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports